"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = require("react-helmet");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _peractoEditor = _interopRequireDefault(require("@peracto/peracto-editor"));

var _peractoConfig = require("@peracto/peracto-config");

var _ContentBlocks = require("./ContentBlocks");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ContentIndex = function ContentIndex() {
  var _blocks$plugins, _blocks$plugins$layou, _blocks$plugins2;

  var peractoConfig = (0, _peractoConfig.useConfig)();

  var _ref = peractoConfig.get('editorConfig') || {},
      _ref$blocks = _ref.blocks,
      blocks = _ref$blocks === void 0 ? {} : _ref$blocks,
      _ref$stylesheets = _ref.stylesheets,
      stylesheets = _ref$stylesheets === void 0 ? [] : _ref$stylesheets,
      theme = _ref.theme,
      _ref$isTailwind = _ref.isTailwind,
      isTailwind = _ref$isTailwind === void 0 ? false : _ref$isTailwind;

  var defaultBlocks = [(0, _ContentBlocks.textPlugin)({
    isTailwind: isTailwind
  }), (0, _ContentBlocks.videoPlugin)({
    isTailwind: isTailwind
  }), (0, _ContentBlocks.youtubePlugin)({
    isTailwind: isTailwind
  }), (0, _ContentBlocks.mapPlugin)({
    isTailwind: isTailwind
  }), (0, _ContentBlocks.formPlugin)({
    isTailwind: isTailwind
  })];
  var Container = (0, _ContentBlocks.containerPlugin)({
    defaultPlugin: (0, _ContentBlocks.textPlugin)({
      isTailwind: isTailwind
    }),
    isTailwind: isTailwind
  }); // Container override if custom container is provided

  var customContainerPlugin = blocks === null || blocks === void 0 ? void 0 : (_blocks$plugins = blocks.plugins) === null || _blocks$plugins === void 0 ? void 0 : (_blocks$plugins$layou = _blocks$plugins.layout) === null || _blocks$plugins$layou === void 0 ? void 0 : _blocks$plugins$layou.find(function (i) {
    return i.name === 'peracto/layout/container';
  });

  if (customContainerPlugin) {
    Container = customContainerPlugin;
  }

  var contentPlugins = {
    content: [],
    layout: [Container]
  };

  if (!(0, _isEmpty["default"])(blocks === null || blocks === void 0 ? void 0 : (_blocks$plugins2 = blocks.plugins) === null || _blocks$plugins2 === void 0 ? void 0 : _blocks$plugins2.content)) {
    var _blocks$plugins3, _blocks$plugins3$cont, _blocks$plugins4, _blocks$plugins4$cont, _blocks$plugins6, _blocks$plugins6$cont, _blocks$plugins7, _blocks$plugins7$cont, _blocks$plugins8, _blocks$plugins8$cont, _blocks$plugins9, _blocks$plugins9$cont, _blocks$plugins10, _blocks$plugins10$con, _blocks$plugins11, _blocks$plugins11$con, _blocks$plugins12, _blocks$plugins12$con, _blocks$plugins13;

    var filteredPlugins = [];

    if (isTailwind) {
      filteredPlugins.push((0, _ContentBlocks.panelsPlugin)());
    }

    if ((_blocks$plugins3 = blocks.plugins) !== null && _blocks$plugins3 !== void 0 && (_blocks$plugins3$cont = _blocks$plugins3.content) !== null && _blocks$plugins3$cont !== void 0 && _blocks$plugins3$cont.some(function (i) {
      return i.name === 'peracto/content/accordion';
    })) {
      filteredPlugins.push((0, _ContentBlocks.accordionPlugin)({
        isTailwind: isTailwind
      }));
    }

    if ((_blocks$plugins4 = blocks.plugins) !== null && _blocks$plugins4 !== void 0 && (_blocks$plugins4$cont = _blocks$plugins4.content) !== null && _blocks$plugins4$cont !== void 0 && _blocks$plugins4$cont.some(function (i) {
      return i.name === 'peracto/content/carousel';
    })) {
      var _blocks$plugins5, _blocks$plugins5$cont;

      var customCarouselBlock = (_blocks$plugins5 = blocks.plugins) === null || _blocks$plugins5 === void 0 ? void 0 : (_blocks$plugins5$cont = _blocks$plugins5.content) === null || _blocks$plugins5$cont === void 0 ? void 0 : _blocks$plugins5$cont.find(function (i) {
        return i.name.endsWith('content/carousel');
      });

      if (customCarouselBlock) {
        filteredPlugins.push(customCarouselBlock);
      } else {
        filteredPlugins.push((0, _ContentBlocks.carouselPlugin)({
          isTailwind: isTailwind
        }));
      }
    }

    var customProductsCarousel = (_blocks$plugins6 = blocks.plugins) === null || _blocks$plugins6 === void 0 ? void 0 : (_blocks$plugins6$cont = _blocks$plugins6.content) === null || _blocks$plugins6$cont === void 0 ? void 0 : _blocks$plugins6$cont.find(function (i) {
      return i.name.endsWith('content/productsCarousel');
    });

    if (customProductsCarousel) {
      filteredPlugins.unshift(customProductsCarousel);
    } else {
      filteredPlugins.unshift((0, _ContentBlocks.productsCarouselPlugin)({
        isTailwind: isTailwind
      }));
    }

    if ((_blocks$plugins7 = blocks.plugins) !== null && _blocks$plugins7 !== void 0 && (_blocks$plugins7$cont = _blocks$plugins7.content) !== null && _blocks$plugins7$cont !== void 0 && _blocks$plugins7$cont.some(function (i) {
      return i.name === 'peracto/content/menuItemsCarousel';
    })) {
      filteredPlugins.push((0, _ContentBlocks.menuItemsCarouselPlugin)({
        isTailwind: isTailwind
      }));
    }

    var customProducts = (_blocks$plugins8 = blocks.plugins) === null || _blocks$plugins8 === void 0 ? void 0 : (_blocks$plugins8$cont = _blocks$plugins8.content) === null || _blocks$plugins8$cont === void 0 ? void 0 : _blocks$plugins8$cont.find(function (i) {
      return i.name.endsWith('content/products');
    });

    if (customProducts) {
      filteredPlugins.unshift(customProducts);
    } else {
      filteredPlugins.unshift((0, _ContentBlocks.productsPlugin)({
        isTailwind: isTailwind
      }));
    }

    var customButton = (_blocks$plugins9 = blocks.plugins) === null || _blocks$plugins9 === void 0 ? void 0 : (_blocks$plugins9$cont = _blocks$plugins9.content) === null || _blocks$plugins9$cont === void 0 ? void 0 : _blocks$plugins9$cont.find(function (i) {
      return i.name.endsWith('content/buttons');
    });

    if (customButton) {
      filteredPlugins.push(customButton);
    } else {
      filteredPlugins.push((0, _ContentBlocks.buttonsPlugin)({
        isTailwind: isTailwind
      }));
    }

    var customMenuItems = (_blocks$plugins10 = blocks.plugins) === null || _blocks$plugins10 === void 0 ? void 0 : (_blocks$plugins10$con = _blocks$plugins10.content) === null || _blocks$plugins10$con === void 0 ? void 0 : _blocks$plugins10$con.find(function (i) {
      return i.name.endsWith('content/menuItems');
    });

    if (customMenuItems) {
      filteredPlugins.unshift(customMenuItems);
    } else {
      filteredPlugins.unshift((0, _ContentBlocks.menuItemsPlugin)({
        isTailwind: isTailwind
      }));
    }

    var customEmbedBlock = (_blocks$plugins11 = blocks.plugins) === null || _blocks$plugins11 === void 0 ? void 0 : (_blocks$plugins11$con = _blocks$plugins11.content) === null || _blocks$plugins11$con === void 0 ? void 0 : _blocks$plugins11$con.find(function (i) {
      return i.name.endsWith('content/embed');
    });

    if (customEmbedBlock) {
      filteredPlugins.unshift(customEmbedBlock);
    } else {
      filteredPlugins.unshift((0, _ContentBlocks.embedPlugin)({
        isTailwind: isTailwind
      }));
    }

    var customImageBlock = (_blocks$plugins12 = blocks.plugins) === null || _blocks$plugins12 === void 0 ? void 0 : (_blocks$plugins12$con = _blocks$plugins12.content) === null || _blocks$plugins12$con === void 0 ? void 0 : _blocks$plugins12$con.find(function (i) {
      return i.name.endsWith('content/image');
    });

    if (customImageBlock) {
      defaultBlocks.splice(1, 0, customImageBlock);
    } else {
      defaultBlocks.splice(1, 0, (0, _ContentBlocks.imagePlugin)({
        isTailwind: isTailwind
      }));
    }

    blocks === null || blocks === void 0 ? void 0 : (_blocks$plugins13 = blocks.plugins) === null || _blocks$plugins13 === void 0 ? void 0 : _blocks$plugins13.content.forEach(function (block) {
      if (!block.name.startsWith('peracto/')) {
        filteredPlugins.push(block);
      }
    });
    contentPlugins = _objectSpread(_objectSpread({}, contentPlugins), {}, {
      content: [].concat(defaultBlocks, filteredPlugins)
    });
  } else {
    contentPlugins = {
      content: defaultBlocks,
      layout: [Container]
    };
  }

  var _blocks$config = blocks.config,
      config = _blocks$config === void 0 ? {} : _blocks$config;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, stylesheets.map(function (style, idx) {
    return /*#__PURE__*/_react["default"].createElement("link", {
      rel: "stylesheet",
      href: style,
      key: "style-".concat(idx)
    });
  })), /*#__PURE__*/_react["default"].createElement(_peractoEditor["default"], {
    defaultPlugin: Container,
    plugins: contentPlugins,
    config: config,
    theme: theme
  }));
};

var _default = ContentIndex;
exports["default"] = _default;